// src/pnl/utils/sub-helpers/StorageKeys.tsx
import { APP_PREFIX } from "./Constants";
import { clearVoyageDriversStore } from "./Store";

/**
 * Build a prefix for a specific voyage.
 * Examples:
 *  - "voyagePnl:"
 *  - "voyagePnl:TC123:"
 *  - "voyagePnl:TC123:456:"
 */
export const getVoyagePrefix = (tcCode?: string | null, voyageNo?: string | number | null) => {
  const parts = [APP_PREFIX];
  if (tcCode) parts.push(String(tcCode));
  if (voyageNo !== undefined && voyageNo !== null) parts.push(String(voyageNo));
  return parts.join(":") + ":"; // trailing ":" to keep namespace precise
};

/** Deterministic key builder used across the app. */
export const getLocalKey = (
  scope: string, // e.g. "rate" | "quantity" | "impact" | "unit" | "flag" | "comment"
  name: string, // e.g. "Freight-Rate-<driver>"
  tcCode: string | undefined,
  voyageNo: string | undefined,
) => {
  const prefix = getVoyagePrefix(tcCode, voyageNo);
  return `${prefix}${scope}:${name}`;
};

export const clearLocalStorageByPrefix = (prefix: string) => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(prefix)) keysToRemove.push(k);
  }
  keysToRemove.forEach((k) => localStorage.removeItem(k));
};

export const cleanupVoyageLocalState = (tcCode: string, voyageNo: string) => {
  clearVoyageDriversStore(tcCode, voyageNo);

  const voyagePrefix = getVoyagePrefix(tcCode, voyageNo);
  clearLocalStorageByPrefix(voyagePrefix);
};
